import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import style from '../../style/components/signin/CloseAccount.module.scss';

const CloseAccountWarning = () => (
  <div className={style.warning}>
    <p>
      <Trans
        i18nKey="account.close.notice_govBenefits"
        components={{ strong: <strong /> }}
      />
    </p>
  </div>
);

const CloseAccount = ({
  handleCloseAccount,
  hasStateWorkforceCredential,
  modalDisplay,
}) => {
  const { t } = useTranslation();

  const learnMoreLink = (
    <a href="https://help.id.me/hc/en-us/articles/203532014">
      Learn more about account closure
    </a>
  );
  const privacyLink = <a href="https://www.id.me/privacy">Privacy Policy</a>;
  const termsLink = <a href="https://www.id.me/terms">Terms of Service</a>;
  const supportLink = (
    <a href="https://help.id.me/hc/en-us/requests/new">
      contact our Support Team
    </a>
  );

  return (
    <main
      className={`${style.close} ${modalDisplay ? style.modalDisplay : ''}`}
    >
      {modalDisplay ? null : (
        <h2 className={style.title}>{t('account.close.heading_page')}</h2>
      )}
      {hasStateWorkforceCredential && <CloseAccountWarning />}
      <h3>{t('account.close.heading_whatHappens')}</h3>
      <p>
        {t('account.close.description_timeline')} {learnMoreLink}.
      </p>
      <h3>{t('account.close.heading_safeguarding')}</h3>
      <p>
        <Trans
          i18nKey="account.close.description_retention"
          components={{ privacyLink, termsLink }}
        />
      </p>
      <h3>{t('account.close.heading_canWeHelp')}</h3>
      <p>
        <Trans
          i18nKey="account.close.description_support"
          components={{ supportLink }}
        />
      </p>

      {modalDisplay ? (
        <idme-button
          variant="primary"
          text={t('common.button_continue')}
          layout="fill"
          onClick={handleCloseAccount}
        />
      ) : (
        <idme-button
          variant="secondary"
          size="small"
          text={t('account.close.button_initiateClose')}
          layout="content"
          onClick={handleCloseAccount}
        />
      )}
    </main>
  );
};

CloseAccount.propTypes = {
  handleCloseAccount: PropTypes.func.isRequired,
};

export default memo(CloseAccount);
